import React, { useEffect, useState } from 'react'
import { authHeader, tableHeadersFields, transactionTimeStamp, slugify } from '../../../utils'
import DataTable from '../../elements/DataTable'
// import ScheduledExamination from '../applications/ScheduledExamination'
import DocumentPreview from '../../elements/DocumentPreview'
import DocumentRequest from '../../elements/DocumentRequest'
import { useDispatch, useSelector } from 'react-redux'
import DocumentIcon from '../../elements/icons/DocumentIcon'
import ChevronIcon from '../../elements/icons/ChevronIcon'
import axios from 'axios'
import { ERROR } from '../../../store/types'
import Loader from '../../elements/Loader'
import DownloadableCardMinified from '../downloads/DownloadableCardMinified'

const StudentDetails = ({student, reload, setReload}) => {
    const documentRequestsSelector = useSelector(state => state.documentRequests)
    const dispatch = useDispatch()
    const [loadingOffer, setLoadingOffer] = useState(true);
    const [downloads, setDownloads] = useState([]);

    useEffect(() => {
        const fetchAdmissionOffer = async () => {
            try {
                const headers = authHeader()
    
                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/admission-offers/${student.admissionOffer?._id}?expand=downloads`, { headers })            
    
                setDownloads(response.data.data.downloads)
                setLoadingOffer(false)
            } catch (error) {
                console.log(error)
                dispatch({
                    type: ERROR,
                    error
                })
                setLoadingOffer(false)
            }
        }
        if(student?.admissionOffer?._id){
            fetchAdmissionOffer()
        }
        return () => {
            
        };
    }, [dispatch, student?.admissionOffer?._id]);

    const tableOptions = {
        selectable: false,
        expandable: false,
        clickableRows: false,
        rowAction: (value)=>{}
    }
    
    const columnWidths = {
        school: "w-full lg:w-5/12",
        from: "w-full lg:w-1/12",
        to: "w-full lg:w-1/12",
        schoolType: "w-full lg:w-3/12",
        latestClass: "w-full lg:w-2/12",
    }
    
    const cleanupData = (dataSet) => {
        const data = []
        if (!dataSet) return []
    
        dataSet.forEach((item, itemIndex) => {
          data.push({
            school: <p>{item.school} {item.current ? <span className='text-xs text-green-800 bg-green-500 bg-opacity-10 px-2 py-1 rounded ml-2'>Current</span> : ''}</p>,
            from: item.fromYear,
            to: item.toYear,
            schoolType: <p className='capitalize'>{item.type.toLowerCase()} School</p>,
            latestClass: item.latestClass
          })
        })
    
        return data
    }

    const [downloading, setDownloading] = useState(false);
    const downloadAdmissionLetter = async (dateRange) => {
        console.log('student ->', student)
        if (downloading) return

        try {
            const header = {
              headers: authHeader(),
              responseType: 'blob'
            }

            let url = `${process.env.REACT_APP_BASE_URL}/documents/download/student/${student._id}/${student.admissionLetter}`

            if(dateRange && dateRange !== '') {
                url += dateRange
            }

            setDownloading(true)
            const response =  await axios.get(url, header ) 
    
            const blob = new Blob([response.data], {type: "application/pdf"})
            const receiptUrl = window.URL.createObjectURL(blob)
    
            var link = document.createElement('a');
            link.href = receiptUrl;
            link.download = `vcm-student-admission-letter-${slugify(student.firstName)}-${slugify(student.lastName)}.pdf`;
            setTimeout(() => {
                link.click();
            }, 100);
            setDownloading(false)

        } catch (error) {
            console.debug(error.response)
            setDownloading(null)
            dispatch({
                type: ERROR,
                error
            })
        }
    }

    return (
        <div className='w-full'>
            <div className='w-full xl:flex items-start justify-between gap-x-5'>
                <div className='w-full xl:w-8/12'>
                    <div className='w-full xl:flex items-start gap-x-5'>
                        <div className='w-full px-4'>
                        <p className='uppercase tracking-[0.2em] text-sm text-vcm-purple'>student details</p>

                        <div className='w-full xl:flex items-start gap-x-5 justify-between my-8'>
                            <div className='w-full'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>first name</label>
                            <p className='text-gray-600'>{student.firstName}</p>
                            </div>
                            <div className='w-full mt-[10px] xl:mt-0'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>other name(s)</label>
                            <p className='text-gray-600'>{student.otherNames}</p>
                            </div>
                            <div className='w-full mt-[10px] xl:mt-0'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>last name</label>
                            <p className='text-gray-600'>{student.lastName}</p>
                            </div>
                        </div>
                        <div className='w-full xl:flex items-start gap-x-5 justify-between my-8'>
                            <div className='w-full'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>date of birth</label>
                            <p className='text-gray-600'>{transactionTimeStamp(student.dob).date}</p>
                            </div>
                            <div className='w-full mt-[10px] xl:mt-0'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Gender</label>
                            <p className='capitalize text-gray-600'>{student.gender.toLowerCase()}</p>
                            </div>
                            <div className='w-full mt-[10px] xl:mt-0'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Religion</label>
                            <p className='text-gray-600'>{student.religion}</p>
                            </div>
                        </div>

                        <div className='xl:flex items-start gap-x-5 justify-between my-8'>
                            <div className='w-full'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>nationality</label>
                            <p className='text-gray-600'>{student.nationality}</p>
                            </div>
                            <div className='w-full mt-[10px] xl:mt-0'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>state of origin</label>
                            <p className='capitalize text-gray-600'>{student.state}</p>
                            </div>
                            <div className='w-full mt-[10px] xl:mt-0'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>lga</label>
                            <p className='text-gray-600'>{student.lga}</p>
                            </div>
                        </div>
                        <div className='xl:flex items-start gap-x-5 justify-between my-8'>
                            <div className='w-full'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>tribe</label>
                            <p className='text-gray-600'>{student.tribe}</p>
                            </div>
                            <div className='w-full mt-[10px] xl:mt-0'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Spoken languages</label>
                            <p className='capitalize text-gray-600'>{student.languages.join(', ')}</p>
                            </div>
                            <div className='w-full mt-[10px] xl:mt-0'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Complexion</label>
                            <p className='text-gray-600 capitalize'>{student.complexion.toLowerCase()}</p>
                            </div>
                        </div>

                        <div className='xl:flex items-start gap-x-5 justify-between my-8'>
                            <div className='w-full'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>mother's maiden name</label>
                            <p className='text-gray-600'>{student.mothersMaidenName}</p>
                            </div>
                            <div className='w-full mt-[10px] xl:mt-0'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>father's name</label>
                            <p className='text-gray-600'>{student.fathersName}</p>
                            </div>
                            <div className='w-full mt-[10px] xl:mt-0'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>number of siblings</label>
                            <p className='text-gray-600'>{student.numberOfSiblings}</p>
                            </div>
                        </div>

                        <div className='xl:flex items-start gap-x-5 justify-between my-8'>
                            <div className='w-full'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>sports interests</label>
                            <p className='text-gray-600'>{student.sportsInterests.join(', ')}</p>
                            </div>
                        </div>
                        <div className='xl:flex items-start gap-x-5 justify-between my-8'>
                            <div className='w-full'>
                            <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>hobbies</label>
                            <p className='text-gray-600'>{student.hobbies.join(', ')}</p>
                            </div>
                        </div>

                        {/* <div className='py-4 border-t border-b'>
                            <div className='flex items-end gap-x-5 justify-between'>
                            <div className='w-2/3'> 
                                <label className='text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block'>Amount paid</label>
                                <p className='capitalize text-gray-600 text-lg'>₦{(fee.amount/100).toLocaleString()} <span className='text-xs'>on {transactionTimeStamp(student.payment.createdAt).date} : {transactionTimeStamp(student.payment.createdAt).time}  </span></p>
                            </div>
                            </div>
                        </div> */}
                        
                        </div>
                    </div>

                    <div className='my-12'>
                        <p className='uppercase tracking-[0.2em] text-sm text-vcm-purple'>Schools attended</p>

                        <div className='w-full hidden'>
                        <DataTable
                            tableHeaders={tableHeadersFields(cleanupData(student.schoolsAttended)[0]).headers} 
                            tableData={cleanupData(student.schoolsAttended)} 
                            columnWidths={columnWidths}
                            columnDataStyles={{}}
                            allFields={tableHeadersFields(cleanupData(student.schoolsAttended)[0]).fields}
                            onSelectItems={()=>{}}
                            tableOptions={tableOptions}
                            pagination={null}
                            changePage={()=>{}}
                            updatePerPage={()=>{}}
                            expandedIndex={''}
                            expansion={null}
                        />
                        </div>

                        <div className='w-full xl:hidden'>
                            {student.schoolsAttended.map((school, schoolIndex) => (
                                <div key={schoolIndex} className=' p-[20px] rounded-[8px] border border-gray-200 relative mb-[15px]'>
                                    <h3 className='text-[15px] font-medium mb-[10px]'>{school.school}</h3>
                                    <p className='capitalize'>{school.type.toLowerCase()} School</p>
                                    <p className='text-sm text-gray-600'>from {school.fromYear} to {school.toYear || 'date'}</p>

                                    {school.current ? <span className='text-xs font-space-grotesk text-green-800 bg-green-500 bg-opacity-10 px-2 py-2 absolute bottom-0 right-0 rounded-br-[8px]'>Current</span> : ''}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className='w-full xl:w-4/12 min-h-[800px] h-inherit bg-gray-50 rounded-md p-5 -mt-5'>
                
                {/* {student.scheduledExaminations && student.scheduledExaminations.length > 0 && 
                <>
                    <p className='uppercase tracking-[0.2em] text-xs mt-3 text-vcm-purple'>Scheduled examinations</p>
                    <div className='my-5'>
                    {student.scheduledExaminations.map((exam, examIndex) => (
                    <div key={examIndex}>
                        <ScheduledExamination exam={exam} />
                    </div>
                    ))}
                    </div>
                </>
                } */}
                
                <p className='uppercase tracking-[0.2em] text-xs mt-2 text-vcm-purple'>admission letter</p>

                <div className='my-5'>
                    <div className='w-full border border-gray-300 rounded-[8px] p-3 flex items-center gap-x-2 transition duration-300 hover:shadow-lg'>
                        <div className=' relative'>
                            <DocumentIcon className={`w-12 h-12 text-gray-500`} />
                            <p className='px-[5px] py-[2px] text-[10px] uppercase text-white inline bg-gray-600 absolute bottom-[10px] -left-[2px]'>PDF</p>
                        </div>
                        <div className='w-full'>
                            <p className='text-sm'>Student Admission Letter</p>
                            <button onClick={()=>{downloadAdmissionLetter()}} className='text-gray-400 hover:text-vcm-purple transition duration-200 text-xs flex items-center gap-x-2'>{downloading ? 'Downloading...' : 'Download'} <ChevronIcon className={`w-4 h-4 rotate-180`} /></button>
                        </div>
                    </div>
                </div>

                <p className='uppercase tracking-[0.2em] text-xs mt-2 text-vcm-purple'>documents</p>

                <div className='my-5'>
                    {student.documents.map((doc, docIndex) => (
                        <div className='my-5' key={docIndex}>
                            <DocumentPreview document={doc} />
                        </div>
                    ))}
                </div>

                <p className='uppercase tracking-[0.2em] text-xs mt-8 text-vcm-purple'>document requests</p>

                {documentRequestsSelector?.documentRequests?.documentRequests && documentRequestsSelector?.documentRequests?.documentRequests?.length > 0 
                ? 
                
                <div className='my-5'>
                    {documentRequestsSelector.documentRequests?.documentRequests?.map((doc, docIndex) => (
                    <div className='my-5' key={docIndex}>
                        <DocumentRequest document={doc} reload={()=>{setReload(reload+1)}} />
                    </div>
                    ))}
                </div> 
                
                : 

                <p className='text-xs text-gray-400 mt-3'>No additional documents have been requested for this student at this time. Any requests will show up here.</p>
                
                }

                <p className='uppercase tracking-[0.2em] text-xs mt-6 text-vcm-purple'>downloads</p>
                <p className='text-xs text-gray-600 mt-3'>The following files are available for download for this student.</p>

                {loadingOffer ? 
                    <Loader />
                    :
                    downloads?.length > 0 ? <div className='my-5'>
                        {downloads.map((download, downloadIndex) => (
                            <div className='my-5' key={downloadIndex}>
                                <DownloadableCardMinified 
                                    downloadable={download} 
                                />
                            </div>
                        ))}
                    </div>
                    :
                    <div>
                        <p className='text-xs text-gray-400 mt-3'>No files are available for download </p>
                    </div>
                }

                </div>
            </div>
        </div>
    )
}

export default StudentDetails